import AbstractRsvpDetailsPageController from './abstract-details-controller';

export default class RsvpDetailsGuestsPageController extends AbstractRsvpDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/details/guests-controller.js